import IVideoOptions from '../../typings/IVideoOptions'
import Logger from '../helpers/Logger'
import { addClass } from '../helpers/DOM'
import { VIDEO_TARGET_CLASS } from './StickyVideo'

// Finds all mediavine video scripts, and inserts a targetDiv
// next to it if one doesn't already exist.
export function setupLegacyOptionsDivs(): void {
  const allVideoScripts = getMediavineVideoScripts()
  allVideoScripts.forEach((videoScript) => {
    // findTargetDivIdFromScript() will return the ID that the target div should be
    // even if it doesn't exist.
    const optionsDivId = findTargetDivIdFromScript(videoScript)

    // It's possible that there are duplicate optionsDivs on a page
    let optionsDivs = Array.from(
      document.querySelectorAll(`[id="${optionsDivId}"]`)
    )
    const videoOptions: IVideoOptions =
      window[videoScript.getAttribute('data-options') || '']

    if (optionsDivs.length === 0 && !videoOptions) {
      optionsDivs.push(document.createElement('div'))
      // optionsDiv.id = optionsDivId
      videoScript.insertAdjacentElement('beforebegin', optionsDivs[0])
      Logger.debug('Video: optionsDiv NOT found.  ADDING ONE!', optionsDivId)
    } else if (videoOptions) {
      optionsDivs = [
        document.querySelector(
          `[id="${videoOptions.targetID}"]`
        ) as HTMLDivElement
      ]
    }

    if (optionsDivs.length > 0) {
      // Add VIDEO_TARGET_CLASS and 'data-video-id' to div, in case it's not there.
      optionsDivs.forEach((optionsDiv) => {
        addClass(optionsDiv, VIDEO_TARGET_CLASS)
        optionsDiv.setAttribute('data-video-id', optionsDivId)
      })
    }
  })
}

/**
 * Given a mediavine video script element, this returns the <script>'s id of the options div that matches the script
 * @param videoScript - Mediavine video <script>
 */
export function findTargetDivIdFromScript(
  videoScript: HTMLScriptElement
): string {
  let scriptSlug

  const scriptSrc = videoScript.getAttribute('src') || ''

  // Extract the slug from the script's src attribute.
  // const slugMatches = scriptSrc.match(/\/videos\/([\w]+)\.js/)
  const slugMatches = scriptSrc.match(
    /\/(?:videos|playlists\/(?:.+?))\/([\w-]+)\.js/
  )
  if (slugMatches && slugMatches[1]) {
    scriptSlug = slugMatches[1]
  }

  let optionsDivId
  if (scriptSrc.indexOf('/playlists/') !== -1) {
    optionsDivId = `mediavine-playlist-${scriptSlug}`
  } else {
    optionsDivId = scriptSlug
  }

  return optionsDivId
}

export function getMediavineVideoScripts(): Array<HTMLScriptElement> {
  const selectors = [
    `script[src*='scripts.mediavine.com/videos/']`,
    `script[src*='video.mediavine.com/videos/']`,
    `script[src*='video-staging.mediavine.com/videos/']`,
    `script[src*='localhost:3030/videos/']`,
    `script[src*='scripts.mediavine.com/playlists/']`,
    `script[src*='video.mediavine.com/playlists/']`,
    `script[src*='video-staging.mediavine.com/playlists/']`,
    `script[src*='localhost:3030/playlists/']`
  ].join(',')
  const scripts = document.querySelectorAll(selectors) as NodeListOf<
    HTMLScriptElement
  >

  // if we can find the slug from the script, it's a video script!
  return Array.from(scripts).filter(
    (script) => !!findTargetDivIdFromScript(script)
  )
}
